import { newError } from '../errors';
import * as actionTypes from '../../constants/actions';

import create from '../../api/comments/create';

const createCommentStart = () => ({
  type: actionTypes.COMMENTS_CREATE,
  status: 'started',
});

const createCommentSuccess = (comment, postId, dispatch) => {
  dispatch({
    type: actionTypes.COMMENTS_CREATE,
    status: 'success',
    comment,
    postId,
  });
};

const createCommentError = (commentData, error, dispatch) => {
  dispatch(newError(error, 'createPostError'));
  dispatch({
    type: actionTypes.COMMENTS_CREATE,
    status: 'error',
    commentData,
    error,
  });
};

const createComment = (commentData) => async (dispatch) => {
  if (!commentData.content) {
    return createCommentError(
      commentData,
      'Missing properties in commentData',
      dispatch
    );
  }

  dispatch(createCommentStart());
  try {
    const comment = await create({
      postId: commentData.postId,
      content: commentData.content,
      parent: commentData.parent,
      root: commentData.root,
    });
    return createCommentSuccess(comment, commentData.postId, dispatch);
  } catch (error) {
    return createCommentError(commentData, error, dispatch);
  }
};

export default createComment;
